module.exports = {"API_HOST":"https://adminapi.prepninja.app","REDIRECT_URI":"https://admin.prepninja.app/login/callback"};